// Radix Select forbids an empty string value, so "no filter" needs a sentinel.
export const FILTER_ALL_VALUE = "all";

export const isFilterSet = (value: string) => !!value && value !== FILTER_ALL_VALUE;

export const toFilterString = (value: unknown): string =>
  value === undefined || value === null ? "" : String(value);
